(function () {
  'use strict';

  angular
    .module('rosterScoringReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rosterScoringReport', {
        url: '/roster-scoring-report',
        views : {
			'rosterScoringReportView' : {
				templateUrl : 'roster-scoring-report/views/roster-scoring-report.tpl.html',
				controller : 'RosterScoringReportCtrl',
				controllerAs : 'rosterScoringReport'
			}
		},
      });
  }
}());
